import { nanoid } from 'nanoid';
import type { TFilterCondition, TTableFilter } from '../common';

export interface FilterGroupProps {
  id?: string;
  condition?: TFilterCondition;
  children?: TTableFilter[];
}

export default class FilterGroup {
  id: string;
  type: 'group' = 'group';
  condition: TFilterCondition;
  children: TTableFilter[];

  constructor({ id = nanoid(), condition = 'and', children = [] }: FilterGroupProps) {
    this.id = id;
    this.condition = condition;
    this.children = children;
  }

  get hasChildren() {
    return this.children.length > 0;
  }

  addChild(filter: TTableFilter) {
    this.children.push(filter);
  }

  removeChild(filterId: string) {
    this.children = this.children.filter((child) => child.id !== filterId);
  }

  setCondition(condition: TFilterCondition) {
    this.condition = condition;
  }
}
